import React from 'react';
import fetch from 'isomorphic-fetch';
import classNames from 'classnames';

import GraphiQL from 'graphiql';
import CallToAction from './CallToAction';
import './graphiql_graphcms.css';

function graphQLFetcher(graphQLParams) {
  // TODO: This does not work in dev. Maybe we should pass a header from Lamda Edge dispatcher function (see https://github.com/GraphCMS/graphcms_lambda_api/issues/6)
  return fetch(`https://api.graphcms.com${window.location.pathname}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'x-graphcms-source': 'graphiql:external',
    },
    body: JSON.stringify(graphQLParams),
  }).then(response => response.json());
}

const defaultQuery =
`# Welcome to GraphiQL
#
# GraphiQL is an in-browser tool for writing, validating, and
# testing GraphQL queries.
#
# Type queries into this side of the screen, and you will see
# intelligent typeaheads aware of the current GraphQL type
# schema and live syntax and validation errors highlighted within
# the text.
#
# An example GraphQL query might look like:
#
# query { field(arg: "value") { subField } }
#
# Run Query:      Ctrl-Enter (or press the play button)
# Auto Complete:  Ctrl-Space (or just start typing)
`;

const swapiDefaultQuery =
`# Welcome to GraphiQL
#
# GraphiQL is an in-browser tool for writing, validating, and
# testing GraphQL queries.

# SWAPI - THE STAR WARS API
#
# All the Star Wars data you've ever wanted:
# Planets, Spaceships, Vehicles, People, Films and Species
#
# This port of Paul Hallett´s SWAPI (swapi.co) was made with GraphCMS
# to demonstrate the flexibility of its generated GraphQL API.
#
# Feel free to use the data in your own apps by connecting your
# GraphQL client to:
# https://api.graphcms.com/simple/v1/swapi or
# https://api.graphcms.com/relay/v1/swapi

{
  Starship(name: "Millennium Falcon") {
    name
    hyperdriveRating
    pilots(orderBy: height_DESC) {
      name
      height
      homeworld {
        name
      }
    }
  }
}
`;

export default () => {
  if (window.location.pathname.includes('swapi')) {
    require('./graphiql_swapi_cust.css');
  }

  return (
    <div id='graphiql' className={classNames({ 'swapi': window.location.pathname.includes('swapi') })}>
      <GraphiQL
        editorTheme={window.location.pathname.includes('swapi') ? 'dracula' : ''}
        fetcher={graphQLFetcher}
        defaultQuery={window.location.pathname.includes('swapi') ? swapiDefaultQuery : defaultQuery }
      />
      <CallToAction />
    </div>
)};



// WEBPACK FOOTER //
// ./src/Graphiql.js